import { useState } from 'react';
import { useEquipo } from '../../context/EquipoContext';

const DIMENSIONES = [
  { id: 'puntualidad',  label: 'Puntualidad',   desc: '¿Llegaron a tiempo?',                color: '#1A6BFF' },
  { id: 'fairplay',     label: 'Fair play',      desc: '¿Jugaron limpio y respetaron?',      color: '#1A6BFF' },
  { id: 'ambiente',     label: 'Buen ambiente',  desc: '¿Fue un partido de buen ánimo?',     color: '#FF6B1A' },
  { id: 'organizacion', label: 'Organización',   desc: '¿Estaban bien organizados?',         color: '#FF6B1A' },
];

function Estrellas({ valor, onChange }) {
  return (
    <div style={styles.estrellas}>
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(n => (
        <div
          key={n}
          onClick={() => onChange(n)}
          style={{
            ...styles.estrella,
            background: n <= valor ? '#FF6B1A' : '#E8ECF4',
            color:      n <= valor ? 'white'   : '#9BA5B7',
          }}
        >
          {n}
        </div>
      ))}
    </div>
  );
}

export default function EvaluacionRival({ partido, resultado, onNext, onBack }) {
  const { deporteActivo } = useEquipo();
  const esFutbol = !deporteActivo || deporteActivo === 'futbol';
  const [evaluaciones, setEvaluaciones] = useState({
    puntualidad:  0,
    fairplay:     0,
    ambiente:     0,
    organizacion: 0,
  });
  const [comentario, setComentario] = useState('');
  const [error,      setError]      = useState('');

  const actualizar = (id, valor) => {
    setEvaluaciones(prev => ({ ...prev, [id]: valor }));
    setError('');
  };

  const promedioEval = () => {
    const vals = Object.values(evaluaciones);
    const sum  = vals.reduce((a, b) => a + b, 0);
    return sum > 0 ? (sum / vals.length).toFixed(1) : '--';
  };

  const handleNext = () => {
    const sinEvaluar = Object.values(evaluaciones).some(v => v === 0);
    if (sinEvaluar) {
      setError('Evalúa todas las dimensiones antes de continuar');
      return;
    }
    onNext({ evaluaciones, comentario });
  };

  return (
    <div style={styles.wrap}>
      <h2 style={styles.titulo}>Evalúa a tu rival</h2>
      <p style={styles.sub}>
        Tu evaluación ayuda a otros equipos a conocer a {partido.rival || 'tu rival'}.
        Sé honesto y constructivo.
      </p>

      {/* Resultado del partido — solo mostrar si hay resultado */}
      {resultado && (
        <div style={{
          ...styles.resultadoBanner,
          background: resultado.ganamos ? 'rgba(22,163,74,0.1)'
                    : resultado.empate  ? 'rgba(255,107,26,0.1)'
                    : 'rgba(239,68,68,0.1)',
          borderColor: resultado.ganamos ? '#86EFAC'
                     : resultado.empate  ? '#FED7AA'
                     : '#FCA5A5',
        }}>
          <div style={styles.resultadoScore}>
            {esFutbol
              ? `${resultado.golesLocal} – ${resultado.golesVisitante}`
              : `${resultado.golesLocal} sets a ${resultado.golesVisitante}`}
          </div>
          <div style={{
            ...styles.resultadoLabel,
            color: resultado.ganamos ? '#16A34A'
                 : resultado.empate  ? '#FF6B1A'
                 : '#EF4444',
          }}>
            {resultado.ganamos ? '🏆 Victoria'
            : resultado.empate ? '🤝 Empate'
            : '😔 Derrota'}
          </div>
        </div>
      )}

      {/* Dimensiones */}
      <div style={styles.dimensionesList}>
        {DIMENSIONES.map(({ id, label, desc, color }) => (
          <div key={id} style={styles.dimensionCard}>
            <div style={styles.dimensionHeader}>
              <div>
                <div style={styles.dimensionLabel}>{label}</div>
                <div style={styles.dimensionDesc}>{desc}</div>
              </div>
              <div style={{
                ...styles.dimensionScore,
                color: evaluaciones[id] > 0 ? color : '#9BA5B7',
              }}>
                {evaluaciones[id] > 0 ? evaluaciones[id] + '.0' : '--'}
              </div>
            </div>
            <Estrellas
              valor={evaluaciones[id]}
              onChange={v => actualizar(id, v)}
            />
          </div>
        ))}
      </div>

      {/* Promedio */}
      {Object.values(evaluaciones).every(v => v > 0) && (
        <div style={styles.promedioWrap}>
          <div style={styles.promedioLabel}>Evaluación total</div>
          <div style={styles.promedioNum}>{promedioEval()}</div>
          <div style={styles.promedioSub}>promedio de las 4 dimensiones</div>
        </div>
      )}

      {/* Comentario */}
      <div style={styles.campo}>
        <label style={styles.label}>
          Comentario sobre el rival (opcional)
        </label>
        <textarea
          value={comentario}
          onChange={e => setComentario(e.target.value)}
          placeholder="Ej: Buen equipo, llegaron puntual y jugaron limpio..."
          style={styles.textarea}
          maxLength={280}
        />
        <span style={styles.charCount}>{comentario.length}/280</span>
      </div>

      {error && <p style={styles.error}>{error}</p>}

      <div style={styles.botones}>
        <button style={styles.btnBack} onClick={onBack}>← Atrás</button>
        <button style={styles.btnNext} onClick={handleNext}>
          Enviar evaluación →
        </button>
      </div>
    </div>
  );
}

const styles = {
  wrap: { width: '100%' },
  titulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 26, fontWeight: 800, color: '#141922', marginBottom: 4,
  },
  sub: {
    fontSize: 13, color: '#6B7280',
    fontFamily: "'Barlow', sans-serif", marginBottom: 20, lineHeight: 1.5,
  },
  resultadoBanner: {
    border: '1.5px solid',
    borderRadius: 12, padding: '14px',
    display: 'flex', alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  resultadoScore: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 32, fontWeight: 800, color: '#141922',
  },
  resultadoLabel: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 20, fontWeight: 800,
  },
  dimensionesList: {
    display: 'flex', flexDirection: 'column',
    gap: 12, marginBottom: 16,
  },
  dimensionCard: {
    background: '#F4F6FA', borderRadius: 12, padding: '14px',
  },
  dimensionHeader: {
    display: 'flex', justifyContent: 'space-between',
    alignItems: 'flex-start', marginBottom: 10,
  },
  dimensionLabel: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 16, fontWeight: 700, color: '#141922', marginBottom: 2,
  },
  dimensionDesc: {
    fontSize: 11, color: '#9BA5B7',
    fontFamily: "'Barlow', sans-serif",
  },
  dimensionScore: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 22, fontWeight: 800,
  },
  estrellas: {
    display: 'flex', gap: 4,
  },
  estrella: {
    width: 28, height: 28, borderRadius: 6,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 12, fontWeight: 700,
    cursor: 'pointer', transition: 'all 0.1s',
  },
  promedioWrap: {
    background: '#0D1117', borderRadius: 12,
    padding: '16px', textAlign: 'center',
    marginBottom: 16,
  },
  promedioLabel: {
    fontSize: 11, fontWeight: 700,
    color: 'rgba(255,255,255,0.3)',
    textTransform: 'uppercase', letterSpacing: '0.05em',
    fontFamily: "'Barlow', sans-serif", marginBottom: 4,
  },
  promedioNum: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 48, fontWeight: 800, color: '#FF6B1A', lineHeight: 1,
  },
  promedioSub: {
    fontSize: 12, color: 'rgba(255,255,255,0.3)',
    fontFamily: "'Barlow', sans-serif", marginTop: 4,
  },
  campo: { marginBottom: 16 },
  label: {
    display: 'block', fontSize: 11, fontWeight: 700,
    color: '#6B7280', textTransform: 'uppercase',
    letterSpacing: '0.05em', marginBottom: 6,
    fontFamily: "'Barlow', sans-serif",
  },
  textarea: {
    width: '100%', padding: '11px 14px',
    border: '1.5px solid #E8ECF4', borderRadius: 10,
    fontSize: 13, color: '#141922',
    fontFamily: "'Barlow', sans-serif",
    outline: 'none', boxSizing: 'border-box',
    resize: 'none', height: 90,
  },
  charCount: {
    fontSize: 11, color: '#9BA5B7',
    fontFamily: "'Barlow', sans-serif",
    float: 'right', marginTop: 3,
  },
  error: {
    color: '#EF4444', fontSize: 12,
    fontFamily: "'Barlow', sans-serif", marginBottom: 12,
  },
  botones: {
    display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10,
  },
  btnBack: {
    padding: '13px', background: 'white',
    border: '1.5px solid #E8ECF4', borderRadius: 12,
    fontSize: 14, fontWeight: 700, color: '#6B7280',
    cursor: 'pointer',
    fontFamily: "'Barlow Condensed', sans-serif",
  },
  btnNext: {
    padding: '13px', background: '#1A6BFF', border: 'none',
    borderRadius: 12,
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 17, fontWeight: 800, color: 'white', cursor: 'pointer',
  },
};